/**
 * avatars/presets/textures/face/face-profile.js
 * Lớp overlay đặc trưng giới tính & độ tuổi (mi mắt nữ, son môi bóng nhẹ, nếp nhăn profile).
 * Được gọi sau mọi nhánh mắt (kể cả fire, star, void, cyber_visor, cyclops).
 */

export function drawFaceProfileOverlay(ctx, size, options = {}) {
  const isFemale = options.gender === 'female';
  const expr = options.expression || 'happy';
  const isAngry = expr === 'angry' || expr === 'yelling';
  const eyeBox = options.eyeBox;

  if (!eyeBox) return;

  // 1. Hàng mi cong sắc nét nữ tính (Eyelashes)
  if (isFemale && !isAngry) {
    if (eyeBox.type === 'dual' && eyeBox.left && eyeBox.right) {
      ctx.fillStyle = '#111827';
      [
        [eyeBox.left.x, -1, eyeBox.left.w, eyeBox.left.y],
        [eyeBox.right.x, 1, eyeBox.right.w, eyeBox.right.y]
      ].forEach(([ex, side, ew, ey]) => {
        // Viền mí trên sắc nét
        ctx.fillRect(ex - size * 0.01, ey - size * 0.018, ew + size * 0.02, size * 0.022);
        // Đuôi mi cong vút vểnh lên
        const outerX = side < 0 ? ex - size * 0.045 : ex + ew + size * 0.005;
        ctx.fillRect(outerX, ey - size * 0.04, size * 0.04, size * 0.02);
        ctx.fillRect(outerX + side * size * 0.008, ey - size * 0.004, size * 0.034, size * 0.017);
      });
    } else if (eyeBox.type === 'cyclops' && eyeBox.center) {
      // Hàng mi cong quyến rũ hai bên góc trên mắt Độc Nhãn Cyclops
      const { x: cX, y: cY, r: eyeR } = eyeBox.center;
      ctx.fillStyle = '#111827';

      // Mi trên bên trái vểnh sang Tây Bắc
      const leftOuterX = cX - eyeR * 0.88;
      const leftOuterY = cY - eyeR * 0.65;
      ctx.fillRect(leftOuterX - size * 0.04, leftOuterY - size * 0.03, size * 0.045, size * 0.022);
      ctx.fillRect(leftOuterX - size * 0.025, leftOuterY, size * 0.03, size * 0.018);

      // Mi trên bên phải vểnh sang Đông Bắc
      const rightOuterX = cX + eyeR * 0.88;
      const rightOuterY = cY - eyeR * 0.65;
      ctx.fillRect(rightOuterX - size * 0.005, rightOuterY - size * 0.03, size * 0.045, size * 0.022);
      ctx.fillRect(rightOuterX - size * 0.005, rightOuterY, size * 0.03, size * 0.018);

      // Viền mí trên cong nhẹ ôm lấy mắt độc nhãn
      ctx.beginPath();
      ctx.arc(cX, cY, eyeR + size * 0.015, Math.PI * 1.25, Math.PI * 1.75);
      ctx.lineWidth = size * 0.022;
      ctx.strokeStyle = '#111827';
      ctx.stroke();
    }
    // Nếu là cyber_visor: theo đặc tả, bỏ qua mi mắt
  }
}
